import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../../components/ui/dialog";

export const MAIL_KEY = "tpoz_mail";

export function getMailAcces() {
  try {
    const v = JSON.parse(localStorage.getItem(MAIL_KEY));
    return v?.email ? v : null;
  } catch {
    return null;
  }
}

export function EmailGate({ open, onOpenChange, experience, onGranted }) {
  const [form, setForm] = useState({ email: "", consent: false });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/acces", { ...form, experience });
      const v = { email: form.email.trim().toLowerCase() };
      localStorage.setItem(MAIL_KEY, JSON.stringify(v));
      onGranted(v);
    } catch (err) {
      toast.error("Accès impossible", {
        description: formatApiError(err.response?.data?.detail) || err.message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} data-testid="email-gate" className="rounded-3xl bg-[#FBF7EF] sm:max-w-md">
        <DialogHeader>
          <span className="mb-2 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#C6870F]/12 text-[#A66E08]">
            <Mail className="h-6 w-6" strokeWidth={1.6} />
          </span>
          <DialogTitle className="font-serif text-2xl font-medium text-[#2E2A22]">
            Entrez votre adresse mail pour voir le détail de cette expérience et de toutes les autres.
          </DialogTitle>
          <DialogDescription className="text-[#6B6355]">
            Une seule fois : l'accès est immédiat et ne sera plus demandé sur cet appareil.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="eg-email">Adresse mail *</Label>
            <Input
              id="eg-email"
              type="email"
              data-testid="email-gate-email"
              required
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              placeholder="vous@exemple.com"
            />
          </div>
          <label className="flex items-start gap-3 rounded-xl bg-white p-3 text-sm text-[#2E2A22]">
            <input
              type="checkbox"
              data-testid="email-gate-consent"
              checked={form.consent}
              onChange={(e) => setForm((f) => ({ ...f, consent: e.target.checked }))}
              className="mt-0.5 h-4 w-4 shrink-0 accent-[#C6870F]"
            />
            <span>J'accepte de recevoir des informations de T'POZ. (facultatif)</span>
          </label>
          <button
            type="submit"
            data-testid="email-gate-submit"
            disabled={submitting}
            className="inline-flex items-center justify-center rounded-full bg-[#C6870F] px-7 py-3.5 text-sm font-semibold text-white hover:bg-[#A66E08] transition-colors disabled:opacity-60"
          >
            {submitting ? "Un instant…" : "Accéder"}
          </button>
          <p className="text-xs text-[#6B6355]/80">
            Vos informations sont destinées uniquement à l'association Plus Belle La Vie 971.{" "}
            <Link to="/mentions-legales" data-testid="email-gate-confidentialite" className="underline underline-offset-2 text-[#A66E08]">
              Politique de confidentialité
            </Link>
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
